import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  icon: {
    marginTop: theme.spacing(0.75),
    fill: theme.palette.grey[700],
  },
}));
